<template>
    <div class="spo-card pa-2 rounded elevation-0 bordered d-flex flex-column gap">
        <div class="text-h6 font-weight-bold">Historique</div>
        <v-timeline side="end" density="compact" v-if="history.length > 0">
            <v-timeline-item v-for="item in history" :key="item.id" dot-color="primary-dark" size="xs">
                <div class=" bg-white rounded bordered pa-2">
                    <div class="text-subtitle-2">Le {{ $moment(item.date).format("DD/MM/YYYY à HH:mm") }}</div>
                    <div>{{ item.message }} <v-icon icon="mdi-link" v-if="item.id_linked_inscription"
                            @click="navigateToInscription(item.id_linked_inscription)" class="cursor-pointer"></v-icon>
                    </div>
                </div>

            </v-timeline-item>
        </v-timeline>

    </div>
</template>

<script>
import AdminService from "@/services/admin.service";
export default {
    props: ["item"],
    data() {
        return {
            history: [],
        }
    },
    async mounted() {
        let data = await AdminService.getHistoryInscription(this.item.id);
        this.history = data;

    },
    methods: {
        navigateToInscription(id_inscription) {
            console.log(id_inscription);
            // Recharger la page si on est déjà sur la même route
            if (this.$route.params.id_inscription == id_inscription) {
                this.$router.go(0);
            } else {
                this.$router.push({
                    name: 'EditInscriptionAdmin',
                    params: {
                        base_module: this.$route.params.base_module,
                        id_inscription: id_inscription
                    }
                });
            }
        }
    }

}
</script>

<style lang="scss" scoped></style>